import { render, staticRenderFns } from "./calyrafit-banner.vue?vue&type=template&id=4710685c&scoped=true&"
import script from "./calyrafit-banner.vue?vue&type=script&lang=js&"
export * from "./calyrafit-banner.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-banner.vue?vue&type=style&index=0&id=4710685c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4710685c",
  null
  
)

export default component.exports